module.exports = __webpack_public_path__ + "static/img/quiz-not-bad@2x.697767ae.png";